interface TableColumnBadgeProps {
  tableName: string
}

/**
 * The badge that displays the table name of a column. Only used if the column is not on the selected source table.
 */
export function TableColumnBadge({ tableName }: TableColumnBadgeProps) {
  return (
    <span className="shrink-0 whitespace-nowrap rounded bg-gray-2 px-1 py-0.5 text-[10px] font-medium leading-tight text-gray-8">
      {tableName}
    </span>
  )
}
